import { post, fetch, patch, put } from '@/utils/http';
const API_ROOT = process.env.VUE_APP_API_URL;

async function getCurrentUserInfo() {
    return fetch(`${API_ROOT}/getInfo`);
}

export {
    getCurrentUserInfo,
}